import trans from "../../../../utils";
import WorkforceTotals from "./WorkforceTotals";

export default function WorkforceReportWidgets({ summary, reportType }) {
  return (
    <>
      <div className="row">
        {summary?.map((item, index) => {
          return (
            <div
              className={`${
                reportType === "efficiency" || reportType === "requests" || reportType === "deviceAssignment"
                  ? "col-lg-3"
                  : "col-lg-4"
              } col-md-6 centered-content`}
              key={index}
            >
              <WorkforceTotals title={trans(item.title)} number={item.number} />
            </div>
          );
        })}
      </div>
    </>
  );
}
